import * as React from 'react';
import get from 'lodash/get';
import cx from 'classnames';
import ChatClient from 'fk-cp-chat';
import getImageUrl from 'utils/getImageUrl';
import FluidCarousel from 'components/FluidCarousel/FluidCarouselVariableWidth';
import SimpleImage from 'components/Common/Image/SimpleImage';
import styles from './ChatProductCarousel.css';
var productCarouselItemViewTypesEnum;
(function (productCarouselItemViewTypesEnum) {
    productCarouselItemViewTypesEnum["PRODUCT_CARD"] = "productCard";
    productCarouselItemViewTypesEnum["BUTTON_BIG"] = "buttonBig";
})(productCarouselItemViewTypesEnum || (productCarouselItemViewTypesEnum = {}));
export default class ChatProductCarousel extends React.Component {
    constructor(props) {
        super(props);
        this.handleViewMoreClick = buttonData => {
            this.chatClient.sendWidgetAction(this.props.selectedChat, get(buttonData, 'data.action.params.chatMessage'));
            this.props.messageSendCallback();
        };
        this.handleViewDetailsClick = productCardData => {
            this.chatClient.sendWidgetAction(this.props.selectedChat, get(productCardData, 'data.action.params.chatMessage'));
            this.props.messageSendCallback();
        };
        this.chatClient = ChatClient.getInstance();
    }
    render() {
        const { products } = this.props;
        if (!products) {
            return null;
        }
        return (<div className={styles['chat-product-carousel']}>
				<FluidCarousel firstItemClass={styles['first-item']} lastItemClass={styles['last-item']}>
					{products.map((product, index) => {
            const { viewType } = product;
            const buttonData = product.widgetComponents.find(component => component.type === 'button');
            const buttonText = get(buttonData, 'data.value.text');
            if (viewType === productCarouselItemViewTypesEnum.BUTTON_BIG) {
                return (<div key={index} className={styles['chat-product']}>
									<div onClick={() => {
                    this.handleViewMoreClick(buttonData);
                }} className={cx(styles['btn'], styles['view-more-btn'])}>
										{buttonText}
									</div>
								</div>);
            }
            else if (viewType === productCarouselItemViewTypesEnum.PRODUCT_CARD) {
                const productCardData = product.widgetComponents.find(component => component.type === 'productCard');
                if (!productCardData) {
                    return null;
                }
                const value = get(productCardData, 'data.value');
                if (!value) {
                    return null;
                }
                const { image, title, subTitle, price } = value;
                return (<div key={index} className={styles['chat-product']} onClick={() => {
                    this.handleViewDetailsClick(productCardData);
                }}>
									<SimpleImage containerClass={styles['img']} src={getImageUrl(image, '300', '70')} width={144} height={180}/>
									<div className={styles['content-container']}>
										<div className={cx(styles['title'], styles['truncate-text'])}>{title}</div>
										<div className={cx(styles['subtitle'], styles['truncate-text'])}>{subTitle}</div>
										{price && (<div className={cx(styles['price'], styles['truncate-text'])}>{`₹${Number(price).toLocaleString('en-IN')}`}</div>)}
									</div>
									<div className={cx(styles['btn'], styles['view-details-btn'])}>{buttonText}</div>
								</div>);
            }
            else {
                return null;
            }
        })}
				</FluidCarousel>
			</div>);
    }
}
